import Immutable from 'immutable';
import { createSelector } from 'reselect';

export const userSuggest = (state) => state.UserSuggest;

export const userSuggestionsSelector = createSelector(
  [userSuggest],
  (suggestion) => {
    return suggestion.get('list', Immutable.List());
  }
);

export const userSuggestionsSelectorJS = createSelector(
  userSuggestionsSelector,
  (suggestions) => suggestions.toJS()
);
